export default __webpack_public_path__ + "static/competition-0f673c5417b543472598dc0a86bec929.png";